import api from "../api";
import ApiConstant from "../../constants/api.constants";
import { isAxiosError } from "axios";
import { DesiriUser } from "../../models/desiri-user";

const getAllUsers = async () => {
  try {
    const result = await api.get(ApiConstant.getAllUsers);
    return result?.data ?? [];
  } catch (error) {
    console.error("Error fetching all users:", error);
    return [];
  }
};


const addUser = async (userData: any) => {
  try {
    
    const result = await api.post(ApiConstant.addUser, userData);
    return result.data; 
  } catch (error) {
    console.error("Error adding user:", error);
    return null;
  }
};

const getAllDesignations = async () => {
  try {
    const result = await api.get(ApiConstant.getAllDesignations);
     return Array.isArray(result?.data) ? result.data : result?.data?.data ?? [];
  } catch (error) {
    console.error("Error fetching designations:", error);
    return [];
  }
};

 export const getAllMUPlants = async () => {
  try {
    const result = await api.get(ApiConstant.getAllMUPlants);
    return Array.isArray(result?.data) ? result.data : result?.data?.data ?? [];
  } catch (error) {
    console.error("Error fetching manufacturing units:", error);
    return [];
  }
};

const getAllMUPlants1 = async () => {
  try {
    const result = await api.get(ApiConstant.getAllMUPlants1);
    return Array.isArray(result?.data) ? result.data : result?.data?.data ?? [];
  } catch (error) {
    console.error("Error fetching manufacturing units:", error);
    return [];
  }
};
const deleteUser = async (userId: number) => {
  try {
    const result = await api.delete(ApiConstant.deleteDesiriUser, {
      params: { userId },
    });
    return result?.data ?? { isSuccess: false, message: "Unknown error" };
  } catch (error) {
    console.error(`Error deleting user ${userId}:`, error);
    return { isSuccess: false, message: "Error deleting user" };
  }
};

const updateUser = async (userData: DesiriUser) => {
  try {
    // Send the edited record only; table labels and other rows are not updates.
    const { id, name, addressline1, addressline2, govtIDName, govtIDNumber, dob,
      primaryContactNbr, secondaryContactNbr, designationID, gender, posID,
      esinumber, pfnumber, bankNumber } = userData;
    const res = await api.put(ApiConstant.updateDesiriUser, {
      id, name, addressline1, addressline2, govtIDName, govtIDNumber, dob,
      primaryContactNbr, secondaryContactNbr, designationID, gender, posID,
      esiNumber: esinumber, pfNumber: pfnumber, bankNumber
    });
     return res.data; 
  } catch (error) {
    // Do not log Axios requests: this profile contains personal/bank details.
    let message = "Could not update the user. Please retry.";
    if (isAxiosError(error)) {
      const body = error.response?.data;
      if (error.response?.status === 400 && body && typeof body === "object") {
        const fields: Record<string, string> = { id: "user", name: "name", addressline1: "address line 1",
          addressline2: "address line 2", govtidname: "government ID type", govtidnumber: "government ID number",
          dob: "date of birth", primarycontactnbr: "primary contact", secondarycontactnbr: "secondary contact",
          designationid: "designation", gender: "gender", posid: "POS", esinumber: "ESI number",
          pfnumber: "PF number", banknumber: "bank number" };
        const invalid = body.errors && typeof body.errors === "object" ? Object.keys(body.errors)
          .map(key => fields[key.replace(/^\$\./, "").toLowerCase()]).filter(Boolean) : [];
        if (invalid.length) message = `Please check: ${invalid.join(", ")}.`;
        else if (["Choose an available POS for your organization.", "Choose an available designation."].includes(body.message))
          message = body.message;
      } else if (error.response?.status === 404) message = "This user is no longer available. Refresh the list.";
    }
    return { isSuccess: false, message };
  }
};



export default {
  getAllUsers,
  addUser,
  getAllDesignations,
  getAllMUPlants,
  getAllMUPlants1,
  deleteUser,
  updateUser
};
